import {
  Heart,
  Stethoscope,
  Brain,
  Eye,
  AlertTriangle,
  Activity,
  Users,
  Baby,
  Shield,
  Zap
} from 'lucide-react'

export const specialties = [
  {
    id: 'basic-general-care',
    name: 'Basic & General Care',
    description: 'Fundamental nursing care including pain management, confusion, fatigue, fall prevention, and general patient safety',
    icon: Stethoscope,
    count: '20+ conditions'
  },
  {
    id: 'cardiac-care',
    name: 'Cardiac Care',
    description: 'Comprehensive cardiovascular nursing care for heart conditions, arrhythmias, and cardiac emergencies',
    icon: Heart,
    count: '12+ conditions'
  },
  {
    id: 'endocrine-metabolic',
    name: 'Endocrine & Metabolic Care',
    description: 'Diabetes management, thyroid disorders, acid-base imbalances, and electrolyte management',
    icon: Activity,
    count: '25+ conditions'
  },
  {
    id: 'gastrointestinal-care',
    name: 'Gastrointestinal Care',
    description: 'Digestive system disorders, nutrition management, and GI surgical care plans',
    icon: Activity,
    count: '18+ conditions'
  },
  {
    id: 'hematologic-lymphatic',
    name: 'Hematologic & Lymphatic Care',
    description: 'Blood disorders, bleeding conditions, anemia, and lymphatic system care plans',
    icon: Heart,
    count: '12+ conditions'
  },
  {
    id: 'infectious-diseases',
    name: 'Infectious Diseases Care',
    description: 'Infection control, communicable diseases, HIV/AIDS, and antimicrobial therapy care plans',
    icon: Shield,
    count: '7+ conditions'
  },
  {
    id: 'integumentary-care',
    name: 'Integumentary Care',
    description: 'Skin disorders, wound care, burns, pressure ulcers, and tissue integrity nursing care',
    icon: Shield,
    count: '5+ conditions'
  },
  {
    id: 'maternal-newborn',
    name: 'Maternal & Newborn Care',
    description: 'Pregnancy, labor, delivery, postpartum, neonatal care, and obstetric complications',
    icon: Baby,
    count: '20+ conditions'
  },
  {
    id: 'mental-health-psychiatric',
    name: 'Mental Health & Psychiatric Care',
    description: 'Mental health disorders, behavioral interventions, substance abuse, and psychiatric nursing care',
    icon: Brain,
    count: '12+ conditions'
  },
  {
    id: 'musculoskeletal-care',
    name: 'Musculoskeletal Care',
    description: 'Orthopedic conditions, mobility issues, fractures, arthritis, and joint replacement care',
    icon: Activity,
    count: '14+ conditions'
  },
  {
    id: 'neurological-care',
    name: 'Neurological Care',
    description: 'Nervous system disorders, stroke, seizures, spinal cord injuries, and neurological assessments',
    icon: Zap,
    count: '10+ conditions'
  },
  {
    id: 'ophthalmic-care',
    name: 'Ophthalmic Care',
    description: 'Eye disorders, vision impairment, cataracts, glaucoma, and ophthalmologic nursing care',
    icon: Eye,
    count: '3+ conditions'
  },
  {
    id: 'pediatric-care',
    name: 'Pediatric Nursing Care',
    description: 'Child-specific nursing care for infants, children, and adolescents with various conditions',
    icon: Baby,
    count: '9+ conditions'
  },
  {
    id: 'reproductive-care',
    name: 'Reproductive Care',
    description: 'Reproductive health, urological disorders, and gynecological nursing care plans',
    icon: Users,
    count: '6+ conditions'
  },
  {
    id: 'respiratory-care',
    name: 'Respiratory Care',
    description: 'Pulmonary conditions, breathing support, airway management, and respiratory therapy',
    icon: Activity,
    count: '20+ conditions'
  },
  {
    id: 'surgery-perioperative',
    name: 'Surgery & Perioperative Care',
    description: 'Pre-operative, intraoperative, and post-operative nursing care for surgical patients including major procedures',
    icon: Activity,
    count: '13+ conditions'
  },
  {
    id: 'urinary-care',
    name: 'Urinary Care',
    description: 'Renal disorders, dialysis, urinary elimination, kidney diseases, and urological care',
    icon: Activity,
    count: '12+ conditions'
  }
]
